import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import type { Map as MapTypes } from 'mapbox-gl';

import { pushMapAttractions } from 'src/components/Mapbox/analitics';
import type { Layer } from '../../types';

type LayersControlProps = {
  map: MapTypes;
  disabled?: boolean;
} & Layer;

/**
 * Кнопка для heatmap слоя
 */
export const LayerButton = (props: LayersControlProps): JSX.Element => {
  const {
    map,
    id: layerID,
    name,
    icon: Icon,
    borderRadius,
    activeBgColor,
    dataLayerName,
    disabled = false,
  } = props;

  const [active, setActive] = useState(false);

  useEffect(() => {
    const visibilityValue = active ? 'visible' : 'none';
    map.setLayoutProperty(layerID, 'visibility', visibilityValue);
  }, [layerID, active, map]);

  const toggleHandler = () => {
    setActive((current) => !current);

    pushMapAttractions(active, dataLayerName);
  };

  return (
    <Button
      title={name}
      disabled={disabled}
      onClick={toggleHandler}
      $borderRadius={borderRadius}
      $bgColor={active ? activeBgColor : ''}
    >
      <IconWrapper isActive={active}>
        <Icon />
      </IconWrapper>
    </Button>
  );
};

const Button = styled.button<{
  $bgColor: string;
  $borderRadius?: string;
}>`
  width: 48px;
  height: 48px;
  background: #fff;
  cursor: pointer;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bgColor }) => $bgColor};

  ${({ $borderRadius }) => $borderRadius}
`;

const IconWrapper = styled.span<{ isActive: boolean }>`
  width: 36px;
  height: 36px;

  svg {
    stroke: ${({ isActive }) => (isActive ? '#fff' : '#4d4d4d')};
  }
`;
